import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AlertService } from '@shared/services/alert.service';

@Injectable()
export class ErrorCodeInterceptor implements HttpInterceptor {

  constructor(
    private alertService: AlertService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        switch (error.status) {
          case 400:
          case 401:
          case 403:
          case 404:
          case 997:
            let errorCode = error.error;
            
            if (error.error instanceof ArrayBuffer) {
              errorCode = +String.fromCharCode(...new Int8Array(error.error))
            }

            if (errorCode && !isNaN(errorCode)) {
              this.alertService.danger(errorCode);
            }

            return throwError(() => error);
          default:
            return throwError(() => error);
        }
      })
    );
  }
}
